import { sdkOpenLink } from '@utils/sdkCtrl'
import { useCopy } from '@hooks/useCopy'
import { getShareImg } from '@utils/index'
import LanguageHook from '@hooks/language';
const { curLang, langData } = LanguageHook();
const matchHost = window.location.host.match(/\.?([A-za-z0-9]*\.(com|hk|vn))/);
const HOST = matchHost ? matchHost[1] : 'gnjoy.hk'
const aid = window.activity_name; // 活动标识必填todo
const gameId = 386; // 游戏ID必填todo
const pageUrl = `https://gevents.${HOST}/${aid}/index.html`; // 分享链接todo https://gevents.${HOST}/eventTemplate/index.html
const platformShareLink = {
  copy: `${pageUrl}?cid=share&scid=copy`, // cid=share&scid=copy
  facebook: `${pageUrl}?cid=share&scid=facebook`, // cid=share&scid=facebook
  line: `${pageUrl}?cid=share&scid=line`, // cid=share&scid=line
  twitter: `${pageUrl}?cid=share&scid=twitter`, // cid=share&scid=twitter
  vk: `${pageUrl}?cid=share&scid=vk`, // cid=share&scid=vk
  naver: `${pageUrl}?cid=share&scid=naver`, // cid=share&scid=naver
  system: `${pageUrl}?cid=share&scid=system`, // cid=share&scid=system
  discord: `${pageUrl}?cid=share&scid=discord`, // cid=share&scid=discord
  kakao: `${pageUrl}?cid=share&scid=kakao`, // cid=share&scid=kakao
  whatsapp: `${pageUrl}?cid=share&scid=whatsapp`, // cid=share&scid=whatsapp
  sdk: `${pageUrl}?cid=share&scid=sdkshare` // cid=share&scid=sdkshare
}
const isUseShortLink = true;
const shareImg = {
  // 'de-DE': getShareImg('de-DE'),
  // 'en-US': getShareImg('en-US'),
  // 'es-ES': getShareImg('es-ES'),
  // 'fr-FR': getShareImg('fr-FR'),
  // 'it-IT': getShareImg('it-IT'),
  // 'ja-JP': getShareImg('ja-JP'),
  // 'ko-KR': getShareImg('ko-KR'),
  // 'pl-PL': getShareImg('pl-PL'),
  // 'pt-PT': getShareImg('pt-PT'),
  // 'ru-RU': getShareImg('ru-RU'),
  // 'th-TH': getShareImg('th-TH'),
  // 'tr-TR': getShareImg('tr-TR'),
  // 'vi-VN': getShareImg('vi-VN'),
  // 'zh-CN': getShareImg('zh-CN'),
  // 'zh-TW': getShareImg('zh-TW')
}

export const getShortLink = (platform, shareParams = {}) => {
  return new Promise(async (resolve) => {
    // 使用 globalGetShareLink 生成带参数的分享链接
    let shareLink = window.globalGetShareLink ? window.globalGetShareLink(shareParams) : (platformShareLink[platform] || pageUrl);

    if (!isUseShortLink) {
      resolve(shareLink)
      return
    }

    try {
      const shortLinkRes = await window.getPlatformShortLink(shareLink);

      if (+shortLinkRes.result === 1 && shortLinkRes.data) {
        // 短链生成成功打点
        window.activityDataLayer.push({
          eventName: "shortLinkSuccess",
          gameId: gameId,
          aid: aid,
        });
        resolve(shortLinkRes.data);
      } else {
        // 短链生成失败打点
        window.activityDataLayer.push({
          eventName: "shortLinkFail",
          gameId: gameId,
          aid: aid,
        });
        console.error('短链生成失败:', shortLinkRes);
        resolve(shareLink);
      }
    } catch (e) {
      // 短链生成异常打点
      window.activityDataLayer.push({
        eventName: "shortLinkFail",
        gameId: gameId,
        aid: aid,
      });
      console.error('短链生成异常:', e);
      resolve(shareLink);
    }
  })
}

export const shareConfig = {
  title: '',
  content: '',
  img: [],
}

let isRunInSdk = false
let isSupportSdkShare = false

export const checkSdkShare = () => {
  const shareSdkInst = new ShareSdk()
  isRunInSdk = shareSdkInst.isRunInSdk()
  try {
    isSupportSdkShare = shareSdkInst.isSupportSdkShare()
  } catch (e) {
    isSupportSdkShare = false
  }
}

export const supportSdkShare = () => {
  return isRunInSdk && isSupportSdkShare
}

checkSdkShare()

export const setShareConfig = ({ title, content, img }) => {
  if (title) shareConfig.title = title
  if (content) shareConfig.content = content
  if (img) shareConfig.img = img
}

export const sdk = () => {
  const shareSdkInst = new ShareSdk()
  const sdkSetContent = content => {
    shareSdkInst.setContent(content)
  }
  const sdkSetShareImageArr = imageArr => {
    shareSdkInst.setShareImageArr(imageArr)
  }
  const sdkSetUrl = url => {
    shareSdkInst.setUrl(url)
  }
  const sdkShare = ({ content }) => {
    let link = platformShareLink['sdk'] || pageUrl;
    sdkSetUrl(window.globalGetGotoLink({link}))
    // sdkSetUrl(getShortLink('sdk'))
    sdkSetShareImageArr([shareImg[curLang] || ''])
    sdkSetContent(content)
    shareSdkInst.share()
    //  打点 点击分享 sdk
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'sdk',
      aid: aid,
      gameId: gameId,
    });
  }
  return {
    shareSdkInst,
    sdkShare
  }
}

export const fb = appid => {
  let shareFacebookInst = null
  let shareLink = ''
  let link = platformShareLink['facebook'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareFacebookInst = new ShareSdk()
  } else {
    shareFacebookInst = new ShareFacebook(appid)
  }
  const fbSetTitle = title => {
    shareFacebookInst.setTitle(title)
  }
  const fbSetContent = content => {
    shareFacebookInst.setContent(content)
  }
  const fbSetShareImageArr = imageArr => {
    shareFacebookInst.setShareImageArr(imageArr)
  }
  const fbSetUrl = url => {
    shareFacebookInst.setUrl(url)
  }
  const fbShare = () => {
    fbSetTitle(shareConfig.title)
    fbSetContent(shareLink)
    fbSetUrl(shareLink)
    console.log('shareLink', shareLink)
    // if (isRunInSdk && !isSupportSdkShare) {
    //   sdkOpenLink({
    //     link: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fserverless.37games.com%2Fshare%2Findex.html'
    //   })
    //   return
    // }
    shareFacebookInst.share(supportSdkShare() ? 'Facebook' : '')
    // 打点 点击分享 facebook
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'facebook',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('facebook')
  fbSetShareImageArr([shareImg[curLang] || ''])
  return {
    shareFacebookInst,
    fbSetTitle,
    fbSetContent,
    fbSetShareImageArr,
    fbSetUrl,
    fbShare
  }
}

export const twitter = () => {
  let shareTwitterInst = null
  let shareLink = ''
  // shareLink = await getShortLink('twitter') // async 
  let link = platformShareLink['twitter'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareTwitterInst = new ShareSdk()
  } else {
    shareTwitterInst = new ShareTwitter()
  }
  const twitterSetContent = content => {
    shareTwitterInst.setContent(content)
  }
  const twitterSetShareImageArr = imageArr => {
    shareTwitterInst.setShareImageArr(imageArr)
  }
  const twitterSetUrl = url => {
    shareTwitterInst.setUrl(url)
  }
  const getShareText = () => {
    // if (+shareConfig.maxScore > 0) {
    //   return getTextByLang('en-US', 'shareDescScore').replace(
    //     'xxx',
    //     shareConfig.maxScore
    //   )
    // }
    // return getTextByLang('en-US', 'shareDefaultDesc')
    return shareConfig.content
  }
  const twitterShare = () => {
    twitterSetContent(getShareText() + shareLink)
    // twitterSetUrl(shareLink)
    shareTwitterInst.share(supportSdkShare() ? 'Twitter' : '')
    // 打点 点击分享 twitter
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'twitter',
      aid: aid,
      gameId: gameId,
    });
  }
  // 标题和图片另外在html的head中设置
  twitterSetShareImageArr([shareImg[curLang] || ''])
  return {
    shareTwitterInst,
    twitterSetContent,
    twitterSetShareImageArr,
    twitterSetUrl,
    twitterShare
  }
}

export const naver = () => {
  let shareNaverInst = null
  let shareLink = ''
  let link = platformShareLink['naver'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareNaverInst = new ShareSdk()
  } else {
    shareNaverInst = new ShareNaver()
  }
  const naverSetTitle = title => {
    shareNaverInst.setTitle(title)
  }
  const naverSetShareImageArr = imageArr => {
    shareNaverInst.setShareImageArr(imageArr)
  }
  const naverSetUrl = url => {
    shareNaverInst.setUrl(url)
  }
  const naverShare = () => {
    naverSetTitle(shareConfig.title + shareLink)
    naverSetUrl(shareLink)
    shareNaverInst.share(supportSdkShare() ? 'Naver' : '')
    //  打点 点击分享 naver
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'naver',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('naver')
  naverSetShareImageArr([shareImg[curLang] || ''])
  return {
    shareNaverInst,
    naverSetTitle,
    naverSetShareImageArr,
    naverSetUrl,
    naverShare
  }
}

export const line = () => {
  let shareLineInst = null
  let shareLink = ''
  let link = platformShareLink['line'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareLineInst = new ShareSdk()
  } else {
    shareLineInst = new ShareLine()
  }
  const lineSetUrl = url => {
    shareLineInst.setUrl(url)
  }
  const lineShare = () => {
    lineSetUrl(shareLink)
    shareLineInst.share(supportSdkShare() ? 'Line' : '')
    //  打点 点击分享 line
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'line',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('line')
  return {
    shareLineInst,
    lineSetUrl,
    lineShare
  }
}

export const vk = () => {
  let shareVkInst = null
  let shareLink = ''
  let link = platformShareLink['vk'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareVkInst = new ShareSdk()
  } else {
    shareVkInst = new ShareVk()
  }
  const vkSetUrl = url => {
    shareVkInst.setUrl(url)
  }
  const vkShare = () => {
    vkSetUrl(shareLink)
    shareVkInst.share(supportSdkShare() ? 'VK' : '')
    //  打点 点击分享 vk
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'vk',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('vk')
  return {
    shareVkInst,
    vkShare
  }
}

export const system = () => {
  let shareSystemInst = null
  let shareLink = ''
  let link = platformShareLink['system'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  let systemIsSupport = false
  if (supportSdkShare()) {
    shareSystemInst = new ShareSdk()
    systemIsSupport = true
  } else {
    shareSystemInst = new ShareSystem()
    systemIsSupport = shareSystemInst.isSupport() // 判断是否支持系统分享。true为支持，false为不支持
  }
  const systemSetTitle = title => {
    shareSystemInst.setTitle(title)
  }
  const systemSetContent = content => {
    shareSystemInst.setContent(content)
  }
  const systemSetUrl = url => {
    shareSystemInst.setUrl(url)
  }
  const systemShare = () => {
    systemSetTitle(shareConfig.title)
    systemSetContent(shareLink)
    systemSetUrl(shareLink)
    if (systemIsSupport) {
      console.log(shareSystemInst.name)
      shareSystemInst.share(supportSdkShare() ? 'System' : '')
      //  打点 点击分享 system
      window.activityDataLayer.push({
        eventName: 'share',
        eventType: 'system',
        aid: aid,
        gameId: gameId,
      });
    }
  }
  // shareLink = getShortLink('system')
  return {
    shareSystemInst,
    systemIsSupport,
    systemSetTitle,
    systemSetContent,
    systemSetUrl,
    systemShare
  }
}

export const discord = link => {
  let shareLink = ''
  shareLink = platformShareLink['discord'] || pageUrl;
  shareLink = window.globalGetGotoLink({link: shareLink});
  const discordShare = () => {
    useCopy(shareConfig.title + shareLink)
    sdkOpenLink({
      link
    })
    //  打点 点击分享 discord
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'discord',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('discord')
  return {
    discordShare
  }
}

export const kakao = appKey => {
  let shareKaKaoInst = null
  let shareLink = ''
  let link = platformShareLink['kakao'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  if (supportSdkShare()) {
    shareKaKaoInst = new ShareSdk()
  } else {
    shareKaKaoInst = new ShareKaKao(appKey)
  }
  const systemSetTitle = title => {
    shareKaKaoInst.setTitle(title)
  }
  const systemSetContent = content => {
    shareKaKaoInst.setContent(content)
  }
  const systemSetUrl = url => {
    shareKaKaoInst.setUrl(url)
  }
  const kakaoShare = () => {
    systemSetTitle(shareConfig.title)
    systemSetContent(shareLink)
    systemSetUrl(shareLink)
    shareKaKaoInst.share(supportSdkShare() ? 'Kakao' : '')
    //  打点 点击分享 kakao
    window.activityDataLayer.push({
      eventName: 'share',
      eventType: 'kakao',
      aid: aid,
      gameId: gameId,
    });
  }
  // shareLink = getShortLink('kakao')
  return {
    shareKaKaoInst,
    systemSetTitle,
    systemSetContent,
    systemSetUrl,
    kakaoShare
  }
}

export const whatsapp = () => {
  let shareLink = ''
  let link = platformShareLink['whatsapp'] || pageUrl;
  shareLink = window.globalGetGotoLink({link});
  const whatsappShare = () => {
    let _href = "https://api.whatsapp.com/send?";
    const text = langData.shareContent + encodeURIComponent(shareLink);
    _href += "&text=" + text;//标题
    _href += "&url=" + encodeURIComponent(shareLink);//链接
    window.open(_href);
  }
  return {
    whatsappShare
  }
}